import { render, staticRenderFns } from "./SetServiceGoods.vue?vue&type=template&id=44923af5&scoped=true&"
import script from "./SetServiceGoods.vue?vue&type=script&lang=js&"
export * from "./SetServiceGoods.vue?vue&type=script&lang=js&"
import style0 from "./SetServiceGoods.vue?vue&type=style&index=0&id=44923af5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44923af5",
  null
  
)

export default component.exports